<template>
  <qx-card title="列表">
    <FenceDialog ref="fenceDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="100001" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1002010201">
        <el-dropdown>
          <el-button type="primary" plain>
            导出订单模板
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="downloadTmpl(1)"
              >自有车-智能模式订单模板</el-dropdown-item
            >
            <el-dropdown-item @click.native="downloadTmpl(2)"
              >自有车-承包模式订单模板</el-dropdown-item
            >
            <el-dropdown-item @click.native="downloadTmpl(3)"
              >自有车-报账模式订单模板</el-dropdown-item
            >
            <el-dropdown-item @click.native="downloadTmpl(4)"
              >非自有车订单模板</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions="1002010202">
        <ImportBtn
          title="线路导入"
          bizCodes="imp100048"
          fileUrl="/file/线路档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1300204">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cmCustomerInfoBO.ajax?cmd=doQueryLineAll"
          :params="fullSearchData"
          bizName="客户线路数据导出"
          bizCode="exp100048"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1300201">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'lineCodeRule'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                  <p
                    class="error"
                    v-if="
                      scope.row.validDays > 0 &&
                      scope.row.validDays <= queryData.validDays
                    "
                  >
                    {{ scope.row.validDays }}天后到期
                  </p>
                  <p class="error" v-if="scope.row.validDays <= 0">已过期</p>
                </section>
                <section
                  v-else-if="scope.column.property === 'companyName'"
                  @click="toCustomerDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                    v-else-if="scope.column.property === 'isLineDeviationAlarm'"
                >
                  <span>{{ scope.row.isLineDeviationAlarm ?'是':'否'}}</span>
                </section>
                <section
                    v-else-if="scope.column.property === 'sourceRadius'"
                >
                  <span>{{ scope.row.sourceRadius}}/{{scope.row.desRadius}}</span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="130"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1300203',
                    showCondition: scope.row.isAuth === 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '1300202',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row.lineId),
                  },
                  {
                    permpisions: '1300206',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                  {
                    permpisions: '1002010203',
                    showCondition: true,
                    name: '装卸货有效范围',
                    event: () => showFenceDialog(scope.row),
                  },
                  // {
                  //   permpisions: '1002010204',
                  //   showCondition: true,
                  //   name: '路线偏移报警',
                  //   event: () => toPathPlanning(scope.row),
                  // },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.lineId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import FenceDialog from './fenceDialog';
import {
  customerLineList,
  customerLineDownloadTmpl, removeCustomerLine,
} from 'api/archives';
import {mapState} from 'vuex';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    TableBtn,
    TableSetting,
    FenceDialog,
  },
  data () {
    return {
      queryData: {
        validDays: 30,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'lineId',
        title: [ // 表头
          {
            prop: 'lineCodeName',
            label: '线路名称',
            fixed: true,
          },
          {
            prop: 'lineCodeRule',
            label: '线路编码',
          },
          {
            prop: 'saleDaparmentName',
            label: '归属部门',
          },
          {
            prop: 'companyName',
            label: '客户全称',
          },
          {
            prop: 'mileageNumber',
            label: '承运公里数',
          },
          {
            prop: 'vehicleInfo',
            label: '车型要求',
          },
          {
            prop: 'priceEnumName',
            label: '计价方式',
          },
          {
            prop: 'estimateIncome',
            label: '预估应收',
          },
          {
            prop: 'payWayName',
            label: '结算方式',
          },
          {
            prop: 'reciveTime',
            label: '回单期限',
          },
          {
            prop: 'collectionTime',
            label: '收款期限',
          },
          {
            prop: 'stateName',
            label: '线路状态',
          },
          {
            prop: 'sourceRadius',
            label: '装/卸货范围',
          },
          // {
          //   prop: 'isLineDeviationAlarm',
          //   label: '是否路线偏移报警',
          // },
          {
            prop: 'authStateName',
            label: '待审核状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerLineList,
    // 设置判断条件
    setJudgeConditions (data) {
      this.setFormValFromData(this.queryData, data);
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核线路' : '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.lineId}&type=${type}`,
        full: true,
      });
    },
    toCustomerDetail (item) {
      this.jump({
        label: '客户详情',
        url: '/manage/archives/customer/archives/detail?id=' + item.customerId,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: id ? '修改线路' : '新增线路',
        url: `/manage/archives/customer/line/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.lineCodeName}】这条线路吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeCustomerLine({
          lineId: item.lineId,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
    showFenceDialog (item) {
      this.$refs.fenceDialog.show(item);
    },
    toPathPlanning (item) {
      const query = `lineId=${item.lineId || ''}&sourceAddress=${encodeURIComponent(item.sourceAddress) || ''}&desAddress=${encodeURIComponent(item.desAddress) || ''}&pathName=${encodeURIComponent(item.lineCodeName) || ''}&effectBegin=${Date.parse(new Date(item.effectBegin))}&effectEnd=${Date.parse(new Date(item.effectEnd))}`;
      this.jump({
        label: '编辑路径',
        url: `/manage/operate/track/pathPlanning/edit?${query}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    async downloadTmpl (type) {
      if (this.tableData.selectResult.length === 0) {
        this.$message({
          message: '请先选择导出目标',
          type: 'warning',
        });
        return;
      }
      const lineIds = this.tableData.selectResult.map((item) => item.lineId);
      const res = await customerLineDownloadTmpl({
        type,
        lineIds: lineIds.join(','),
      });
      if (!res.failed) {
        window.open(res.fullPathUrl);
        // this.$message({
        //   message: '任务提交成功，请前往‘导入导出结果查询’查看',
        //   type: 'success',
        // });
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.tableData.title.map((item, index) => {
        if (item.label === '车型要求') {
          this.$nextTick(() => {
            this.tableData.title[index].show = false;
          });
        }
      });

    }

  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
